import styled from 'styled-components';

import { SmallParagraph } from '../../../../../foundations/typefaces/SmallParagraph';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(0.5),

  overflow: 'hidden',

  whiteSpace: 'nowrap',
}));

export const StyledSmallParagraph = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.tertiary.default(),
  cursor: 'default',
}));

export const StyledIcon = styled.div(({ theme: { color, size } }) => ({
  color: color.content.tertiary.default(),
  maxWidth: size.units(1.5),
  width: size.units(1.5),
}));
